import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, updateDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import './ChapterReactions.css';

const REACTIONS = [
  { emoji: '❤️', label: 'Amour' },
  { emoji: '🔥', label: 'Feu' },
  { emoji: '😂', label: 'Drôle' },
  { emoji: '😢', label: 'Triste' },
  { emoji: '😱', label: 'Choqué' },
  { emoji: '🤔', label: 'Hmm' },
];

export default function ChapterReactions({ bookId, chapterIndex }) {
  const { user } = useUser();
  const [reactions, setReactions] = useState({});
  const [myReaction, setMyReaction] = useState(null);
  const [showPicker, setShowPicker] = useState(false);

  const reactionPath = `chapterReactions_${chapterIndex}`;

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'books', bookId), (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data()[reactionPath] || {};
        setReactions(data);
        // Trouver ma réaction
        for (const [emoji, users] of Object.entries(data)) {
          if (users && users.includes(user.id)) {
            setMyReaction(emoji);
            return;
          }
        }
        setMyReaction(null);
      }
    });
    return () => unsub();
  }, [bookId, reactionPath, user.id]);

  const handleReact = async (emoji) => {
    const bookRef = doc(db, 'books', bookId);
    const newReactions = { ...reactions };

    // Retirer l'ancienne réaction
    if (myReaction) {
      newReactions[myReaction] = (newReactions[myReaction] || []).filter(id => id !== user.id);
      if (newReactions[myReaction].length === 0) delete newReactions[myReaction];
    }

    // Ajouter la nouvelle (sauf si c'est la même = toggle off)
    if (emoji !== myReaction) {
      if (!newReactions[emoji]) newReactions[emoji] = [];
      newReactions[emoji].push(user.id);
    }

    await updateDoc(bookRef, { [reactionPath]: newReactions });
    setShowPicker(false);
  };

  const totalReactions = Object.values(reactions).reduce((sum, arr) => sum + (arr ? arr.length : 0), 0);

  return (
    <div className="reactions-section">
      <div className="reactions-bar">
        {Object.entries(reactions).map(([emoji, users]) => (
          users && users.length > 0 && (
            <motion.button
              key={emoji}
              className={'reaction-chip ' + (myReaction === emoji ? 'reaction-chip-active' : '')}
              onClick={() => handleReact(emoji)}
              whileTap={{ scale: 0.9 }}
            >
              {emoji} {users.length}
            </motion.button>
          )
        ))}
        <motion.button
          className="reaction-add"
          onClick={() => setShowPicker(!showPicker)}
          whileTap={{ scale: 0.9 }}
        >
          {showPicker ? '✕' : '+'}
        </motion.button>
      </div>

      {showPicker && (
        <motion.div
          className="reactions-picker"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {REACTIONS.map(r => (
            <motion.button
              key={r.emoji}
              className="reaction-pick"
              onClick={() => handleReact(r.emoji)}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.8 }}
              title={r.label}
            >
              {r.emoji}
            </motion.button>
          ))}
        </motion.div>
      )}
    </div>
  );
}